<template>
  <div class="select-filters d-flex align-items-center flex-wrap">
    <div class="d-flex align-items-start align-items-center">
      <CCheckBox
        label="Recurring"
        :checked="recurrence"
        name="Recurring"
        class="custom-checkbox recurring"
        @update:model-value="setRecurrenceOnly"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "StudentAptPassFilters",
  data: () => ({}),
  computed: {
    ...mapGetters({
      recurrence: "studentAptPass/recurrenceOnly"
    })
  },
  methods: {
    setRecurrenceOnly(data) {
      this.$store.commit("studentAptPass/SET_RECURRENCE_ONLY", data)
    }
  }
}
</script>

<style></style>
